namespace SP {
    interface DataInterface {
        key: string;
        src: () => Promise<any[]>;
    }


    export interface AutoCompleteSettingsInterface {
        searchDelay?: number;
        minLength?: number;
        render?: (item: any) => string;
        noResult?: () => void;
        onSelect?: (item: any) => void;
        cacheResult?: boolean;
        data: DataInterface;
        outputContainerId?: string;
    }


    export class AutoComplete {
        input: HTMLInputElement;
        settings: AutoCompleteSettingsInterface;
        resultList: HTMLUListElement;
        private resultCache: { [keyword: string]: any[] } = {};
        items: any;

        private visible: boolean = false;
        private timeout: NodeJS.Timeout;
        private timeoutBlur: NodeJS.Timeout;
        private searching: boolean;
        private currentKeyword: string;

        constructor(inputQuerySelector: string | HTMLInputElement, settings: AutoCompleteSettingsInterface) {
            var output: HTMLElement = null;
            if (settings.outputContainerId) output = document.querySelector(settings.outputContainerId);

            if (typeof (inputQuerySelector) == "string") {
                this.input = document.querySelector(inputQuerySelector);
            }
            else {
                this.input = inputQuerySelector;
            }

            this.input.classList.add("sp_autocomplete")
            this.settings = settings;

            //set defaults for settings
            if (settings.searchDelay == null) settings.searchDelay = 200;
            if (settings.minLength == null) settings.minLength = 1;
            if (settings.render == null) settings.render = item => "<div class='default'>" + item[settings.data.key] + "</div>";
            if (settings.noResult == null) settings.noResult = () => this.resultList.innerHTML = `<li><div class='default'>No result for '${this.input.value}'</div></li>`;
            if (settings.onSelect == null) settings.onSelect = item => console.log("select item", item);
            if (settings.cacheResult == null) settings.cacheResult = true;

            //create result list
            this.resultList = document.createElement("ul");
            this.resultList.classList.add("sp_resultList");
            this.resultList.id = "resultList";

            if (output)
                output.appendChild(this.resultList);
            else
                this.input.after(this.resultList);
            this.hide();

            //input events
            this.input.addEventListener("keydown", (e) => {
                if (e.which == 40) {
                    this.markItem(this.resultList.querySelector(".selected").nextElementSibling as HTMLElement);
                    e.preventDefault();
                    return false;
                }
                else if (e.which == 38) {
                    this.markItem(this.resultList.querySelector(".selected").previousElementSibling as HTMLElement);
                    e.preventDefault();
                    return false;
                }
                else if (e.which == 13) {
                    this.select(this.resultList.querySelector(".selected"));
                    e.preventDefault();
                    return false;
                }

                return true;
            });

            this.input.addEventListener("input", () => {
                this.startSearch();
            });

            this.input.addEventListener("focus", () => {
                clearTimeout(this.timeoutBlur);
                this.input.select();
                if (!this.visible) this.search();
            });

            this.input.addEventListener("blur", () => {
                this.timeoutBlur = setTimeout(() => {
                    this.hide();
                }, 1000);

            });

        }

        private markItem(html_item: HTMLElement) {
            if (html_item) {
                let current = this.resultList.querySelector(".selected");
                current?.classList.remove("selected");
                html_item.classList.add("selected");
            }
        }

        select(html_item: HTMLElement) {
            if (html_item) {
                this.markItem(html_item);
                var item = this.items[html_item.getAttribute("data-key")];
                if (item != null) {
                    this.input.value = item[this.settings.data.key];
                    this.hide();
                    this.settings.onSelect(item);
                }
            }
        }

        private hide() {
            this.resultList.style.display = 'none';
            this.visible = false;
        }

        private show() {
            this.resultList.style.display = 'block';
            this.visible = true;
        }

        private startSearch() {
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => { this.search() }, this.settings.searchDelay);

        }

        async search() {
            //return if already searching
            if (this.searching) return;



            try {
                //clear timeout
                this.timeout = null;



                let keyword = this.currentKeyword = this.input.value;

                //dont search
                if (keyword.length < this.settings.minLength) return this.hide();

                let result: any[] = null;

                //load from cache
                if (this.settings.cacheResult) result = this.resultCache[keyword];

                if (result == null) {
                    let _this = this;
                    console.log("calling with:", _this);
                    result = await this.settings.data.src.apply(_this);

                    //save to cache
                    if (this.settings.cacheResult) this.resultCache[keyword] = result;
                }


                //only render result if keyword hasn't changed
                if (keyword == this.input.value) {

                    //clear lists
                    this.resultList.innerHTML = "";
                    this.items = {};

                    //render empty result
                    if (result == null || !result.length) this.settings.noResult();

                    //render list
                    else {
                        result.forEach(item => {
                            var key = item[this.settings.data.key];
                            this.items[key] = item;
                            var html_item = this.resultList.appendChild(document.createElement("li"));
                            html_item.classList.add("item");
                            html_item.innerHTML = this.settings.render(item);
                            html_item.setAttribute("data-key", key);

                            html_item.addEventListener("click", () => {
                                this.select(html_item);
                            });

                        });

                        //highlight keywords
                        this.currentKeyword.split(" ").forEach(w => { SP.highlight("#resultList", w); });

                        //mark first item
                        this.markItem(this.resultList.firstChild as HTMLElement);
                    }
                    this.show();
                }


            }
            catch (err) {
                //await SP.alertX("error fetching data, check console!");
                console.error(err);
            }
            finally {
                this.searching = false;

                //research if change
                if (this.currentKeyword != this.input.value) this.search();

            }
        }
    }
}